var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-links"},_vm._l((_vm.links),function(link,$index){return _c('a',{key:$index,attrs:{"href":link.val,"target":"_blank"}},[_c('b-icon',{attrs:{"icon":link.key}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }